import { ITagResult } from '~src/httpClient/serverApi/types/IResponse';
import { TagRequest } from '~src/httpClient/TAG/TagRequest';

export class DeleteSiteSMTPCredentialRequest extends TagRequest<ISiteLuidRequest, ITagResult> {
  constructor(siteLuid: ISiteLuidRequest) {
    super('monolith_grpc', 'deleteSiteSMTPCredential', siteLuid);
  }
}

export interface ISiteLuidRequest {
  site_luid: string;
}